export function getVaultKey(vault: { address: string; network: string }, postfix?: string) {
  return `${vault.address}-${vault.network}${postfix ? `-${postfix}` : ''}`
}
